var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQueue = function SvgQueue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M23 5v8m-4-4h8M7 9.731V24.27c0 1.508 1.753 2.293 2.83 1.266l7.632-7.269a1.76 1.76 0 0 0 0-2.532L9.83 8.465C8.753 7.44 7 8.223 7 9.731Z"
  })));
};
export default SvgQueue;